import React from 'react';
import { useCurrentPreviewMetadata } from 'js/file_viewer/core/queries/preview_metadata';
import { useSsrDocMetadataQuery } from 'js/file_viewer/core/queries/riviera_preview_types/ssr_doc';
import { asyncComponent } from 'js/file_viewer/core/utils/suspense';
import { useDownloadSucceeded } from 'js/file_viewer/hooks/lifecycle_logging';
import { useRivieraTiming } from 'js/file_viewer/logging/hooks';
import { PreviewsTimingEvents, useMarkTimingEventOnMount } from 'js/file_viewer/logging/performance';
const AsyncPreviewDoc = asyncComponent('PreviewDoc', () => import('js/file_viewer/preview_doc/preview_doc'));
export const AsyncPreviewDocWithRiviera = (props) => {
    var _a;
    const { previewKey, previewSessionId } = props;
    const previewData = useCurrentPreviewMetadata();
    const rivieraQuery = useSsrDocMetadataQuery(previewKey, previewData);
    useRivieraTiming(rivieraQuery, previewKey, previewData);
    const rivieraData = (_a = rivieraQuery === null || rivieraQuery === void 0 ? void 0 : rivieraQuery.data) === null || _a === void 0 ? void 0 : _a.apiData.metadata;
    useDownloadSucceeded(previewSessionId, !!rivieraData && !(rivieraData === null || rivieraData === void 0 ? void 0 : rivieraData.needsPassword));
    useMarkTimingEventOnMount(PreviewsTimingEvents.ASYNC_DOC_CONTAINER_MOUNT);
    return React.createElement(AsyncPreviewDoc, { ...props });
};
AsyncPreviewDocWithRiviera.displayName = "AsyncPreviewDocWithRiviera"
//# sourceMappingURL=async_preview_doc.preenvesnextjs.map
